import { useQuery } from '@tanstack/react-query';
import { getBalance, BalanceResponse, MemberStatus } from '@/api/wallet';
import { useAuth } from '@/contexts/AuthContext';

export type { MemberStatus };

export const useBalance = () => {
  const { isAuthenticated } = useAuth();

  return useQuery<BalanceResponse, Error>({
    queryKey: ['balance'],
    queryFn: getBalance,
    staleTime: 1000 * 60, // 1分間はキャッシュを使用
    refetchOnWindowFocus: true, // ウィンドウフォーカス時に再取得
    enabled: isAuthenticated, // 認証済みの場合のみ実行
  });
};
